import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import WarningIcon from '@mui/icons-material/Warning';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import DoneIcon from '@mui/icons-material/Done';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import BlockIcon from '@mui/icons-material/Block';

import { utils } from '../../../util';

import './table.scss';

const IndicatorCell = ({ value, complete, rejected, expiry, style, archived, postponed }) => {
  const caseExpiry = utils.checkTimeDiff(expiry) <= 48;

  const renderIcon = () => {
    if (archived) {
      return <DeleteIcon style={{ color: style }} color='primary' />;
    }
    if (postponed) {
      return <BlockIcon style={{ color: style }} color='primary' />;
    }
    if (rejected) {
      return <WarningIcon style={{ color: style }} color={value ? 'primary' : 'secondary'} />;
    }
    if (complete) {
      return <DoneIcon style={{ color: style }} color={value ? 'primary' : 'secondary'} />;
    }
    if (caseExpiry) {
      return <NewReleasesIcon style={{ color: style }} color={value ? 'primary' : 'secondary'} />;
    }

    return (
      <FiberManualRecordOutlinedIcon
        style={{ color: style }}
        color={value ? 'primary' : 'secondary'}
      />
    );
  };

  return <div className="indicator-cell">{renderIcon()}</div>;
};

IndicatorCell.propTypes = {
  value: PropTypes.bool,
  complete: PropTypes.bool,
  rejected: PropTypes.bool,
  archived: PropTypes.bool,
};

export default memo(IndicatorCell);
